<template>
  <section>
    <div class="m-oa-info">
      <div class="header">
        <p class="r">{{userData.name}}，<a href="javascript:;" @click="signOut()" class="signOut">退出</a></p>
        <div class="logo"></div>
      </div>
    </div>
  </section>
</template>
<script>
  import {
    mapState
  } from "vuex";
  export default {
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      }),
    },
    mounted() {},
    methods: {
      signOut() {
        this.$store.commit('set_userData', '')
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/MHeader.vue